export default {
        name: 'VoucerReport',
        data() {
        return{
            payments: null,
            payementsFields: [
                { key: 'customerId', label: 'Customer Id' },
                { key: 'amountInPence', label: 'Amount In Pence' },
                { key: 'feeInPence', label: 'Fee In Pence' },
                { key: 'creditUsedInPence', label: 'Credit Used In Pence' },
                { key: 'createDateTime', label: 'Create Date Time' },
                { key: 'fulfilled', label: 'Fulfilled' },
                { key: 'fullfillmentDateTime', label: 'Fullfillment Date Time' },
                { key: 'productDescription', label: 'Product Description' },
            ],
            customerVouchers: null,
            customerVouchersFields: [
                { key: 'customerID', label: 'Customer Id' },
                { key: 'discount.merchant.name', label: 'Merchant Name' },
                { key: 'faceValue', label: 'Face Value' },
                { key: 'currentBalance', label: 'Current Balance' },
                { key: 'cost', label: 'Cost' },
                { key: 'saving', label: 'Saving' },
                { key: 'createdDateTime', label: 'Created Date Time' },
            ],
            customerCreditTransactions: null,
            customerCreditTransactionsFields: [
                { key: 'customerID', label: 'Customer Id' },
                { key: 'createdDateTime', label: 'Created Date Time' },
                { key: 'amount', label: 'Amount' }
            ],
            }
        },
        methods: {
        getPayments: function(){
            this.$http.get(this.$config.ApiUri + "/Payments")
                .then((result) => {
                    this.payments = result.data;
                }
            )
        },
        getCustomerVouchers: function(){
            this.$http.get(this.$config.ApiUri + "/Customers/Vouchers")
                .then((result) => {
                    this.customerVouchers = result.data;
                }
            )
        },
        getCustomerCreditTransactions: function(){
            this.$http.get(this.$config.ApiUri + "/Discounts/CustomerCreditTransactions")
                .then((result) => {
                    this.customerCreditTransactions = result.data;
                }
            )
        },
      onLoad() {
          this.getPayments();
          this.getCustomerVouchers();
          this.getCustomerCreditTransactions();
      }
    },
    mounted: function() { this.onLoad(); }
  }